import React from "react";
import { Box, Icon, Stack, Text } from "@storyofams/react-ui";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import { Button } from "~components/common/Button";
import { CheckmarkCircle } from "~components/common/Icons";
import { Image } from "~components/common/Image";

const messages = defineMessages({
  months: "maanden",
  ewgInfo: "(Lager = beter)",
});

interface TableItemProps {
  name: string;
  label: string;
  value?: any;
  useIcon?: boolean;
  url?: string;
  valueW?: any;
}

export const TableItem = ({
  name,
  label,
  value,
  useIcon,
  url,
  valueW,
}: TableItemProps) => {
  const intl = useIntl();

  const renderValue = () => {
    if (name === "houdbaarheid")
      return (
        <Text fontWeight="medium">
          {value} <FormattedMessage {...messages.months} />
        </Text>
      );

    if (name === "ewg_cijfer")
      return (
        <Button
          variant="unstyled"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            width={40}
            height={40}
            src={`https://static.ewg.org/skindeep/img/draw_score/score_image${value}_${value}_1_.png`}
          />
        </Button>
      );

    if (!!value) {
      if (useIcon)
        return <Icon icon={CheckmarkCircle} fontSize={2.25} color="greenish" />;

      return <Text fontWeight="medium">{value}</Text>;
    }

    return (
      <Text fontWeight="medium" pl={useIcon ? "5px" : 0}>
        -
      </Text>
    );
  };

  return (
    <Stack space={[4, 10]}>
      <Box flex={1}>
        <Text maxWidth={[294, "initial"]}>
          {label}{" "}
          {name === "ewg_cijfer" && intl.formatMessage(messages.ewgInfo)}
        </Text>
      </Box>

      <Box
        width={valueW || ["auto", 100]}
        justifyContent={["flex-end", "flex-start"]}
      >
        {renderValue()}
      </Box>
    </Stack>
  );
};
